<script>
import { Bar } from 'vue-chartjs/legacy';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
} from 'chart.js';
ChartJS.register(
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
);
export default {
    name: 'BarChart',
    extends: Bar,
    components: { Bar },
    props: {
        chartData: {
            type: Object,
            required: true,
            default: [],
        },
        chartOptions: {
            type: Object,
            default: null,
        },
    },
};
</script>
